import { useForm } from 'react-hook-form';
import axios from "axios";
import Cookies from 'universal-cookie';
import ObtieneDatosCookies from '../tools/obtieneDatosCookiesUsuario.js';
import devuelveDependenciaConstultada from '../tools/devuelveDependencia.js';
import devuelveCategorias from '../modulos/devuelveCategorias.js';
import convierteExpediente from '../adaptadores/convierteExpediente.js'
import seteaCokieExpediente from './seteaCokieExpediente.js';
import { useState, useEffect } from 'react';
import ModalDevuelveListas from './ModalDevuelveListas.js'
import Modal from './Modal.jsx';
import ModuloDevuelveCursos from '../cadetes/devuelveCursos.jsx';
import ModuloDevuelveCadetes from './devuelveCadetes.jsx';
import CadeteBuscador from '../NCadetes/CadetesBuscador.jsx'
function FormNuevoExpte(props) {
  const cookies = new Cookies();
  const ID = cookies.get('id');
  const [listaDeExpedientes, setListaDeExpedientes] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [modalListaExpedienteIsOpen, setModalListaExpedienteIsOpen] = useState(false);
  const [disableBotonFinalizar, setDisableBotonFinalizar] = useState(false)
  const [modalCadetesOpen, setModalCadeteOpen] = useState(false)
  const [esDeCadete, setEsDeCadete] = useState("")
  const [veoListados, setVeoListados] = useState(false)
  const [veoListadosCadetes, setVeoListadosCadetes] = useState(false)
  const [cursos, setCursos] = useState()
  const [cadetesCurso, setCadeteCurso] = useState()
  const [grupoSeleccionado, setGrupoSeleccionado] = useState("");


  const devuelveTodosExpedientes = async () => {

    const client = axios.create({
      baseURL: process.env.REACT_APP_BASEURL + ""
    });
    try {


      await client.post("expedientes/?cantidad=50").then(f => setListaDeExpedientes(f.data)).then(openModalListaExpediente())
    }
    catch (error) { }

  }
  const fecha = new Date();
  const hoy = "Fecha: " + fecha.toLocaleDateString();

  const URI = 'https://wwwa.isepsantafe.net.ar/expedientes/'

  const parametro = {}
  const usuario = ObtieneDatosCookies()
  const [valorExpt, setValorExpt] = useState('')
  const [apellidoExpte, setapellidoExpte] = useState('')

  const store = async (data) => {
    try {
      setDisableBotonFinalizar(true)
//       console.log(data)
      const resultado = await axios.post(URI + "expedientes/crea", convierteExpediente(data))

      if (resultado) {
        await seteaCokieExpediente(resultado.data.Respuesta).then(window.open('/imprime')).then(() => { props.myID("dale") });
      }
    } catch (error) {
      setDisableBotonFinalizar(false)
    }




  }

  const { register, formState: { errors }, watch, handleSubmit, } = useForm({
    defaultValues: parametro//recupero lo que pasa por parametros
  });
  const devuelveLosCadetes = () => {
    setModalCadeteOpen(true)
  }
  const categorias = devuelveCategorias()
const grupos = [...new Set(
  categorias
    .filter(c => c.vigente)
    .map(c => c.grupo)
)];

const categoriasFiltradas = categorias.filter(
  c => c.grupo === grupoSeleccionado && c.vigente
);
  const onSubmit = (data) => {

    store(data)

  }

  const fechaMinima = '1995-07-08';
  const fechaMaxima = '2005-07-07';
  const titulo =
    'Generacion de Expedientes ';
  const subTitulo = 'del Instituto de Seguridad Publica';


  const tomaIdExpediente = (vañ) => {
    setValorExpt(vañ.id)

    setOpenModal(false)
  }
  const habilitaIdExptAnterior = watch('tieneExptAnterior');
  const esDigitalActivo = watch("esDigital");
  function openModalListaExpediente() {
    setOpenModal(true);
  }

  function closeModalListaExpediente() {
    setOpenModal(false);
  } function afterOpenModal() {
    // references are now sync'd and can be accessed.

  }
  const muestroListaCadetes = async (valor) => {

    const client = axios.create({
      baseURL: process.env.REACT_APP_BASEURL + "cadetes"
    });
    try {



      const cadetesDevueltos = await client.post("/", { "promocion": valor.api })
      if (cadetesDevueltos) {
        setCadeteCurso(cadetesDevueltos.data.sort(function (a, b) {
          return a.cadeteApellido.localeCompare(b.cadeteApellido);
        }))
        setVeoListadosCadetes(true)

      }
    } catch { }



  }
  useEffect(() => {
    muestraCursos()

  }, [modalCadetesOpen]);
  const muestraCursos = async () => {
    setVeoListados(false)
    const client = axios.create({
      baseURL: process.env.REACT_APP_BASEURL + "cadetes/muestraPromociones"
    });
    try {
      const cursosActivos = await client.post('/')
      if (cursosActivos) {
        setCursos(cursosActivos.data)
        setVeoListados(true)
      }
    }
    catch (error) { }
  }

  const tomoCadete = (valor) => {
    setModalCadeteOpen(false)
    setEsDeCadete(valor.cadeteDni)
  }
  const customStyles = {
    content: {

      overflowY: "scroll", zIndex: "10",


    },
  };
  return (
    <div>
      <Modal
        isOpen={openModal}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModalListaExpediente}
        style={customStyles}
        ariaHideApp={false}
      >
        <div className=" btn-group"> <button className="btn btn-danger" style={{ display: "flex", alignContent: "flex-end" }} onClick={closeModalListaExpediente}>x </button> <a style={{ alignSelf: "center" }} ><strong>Consulta Lista de Expediente: </strong></a>

        </div>
        <ModalDevuelveListas listaExpedientes={listaDeExpedientes.filter(x => x.idExptPosterior
          == null)} myID={(value2) => tomaIdExpediente(value2)} />



      </Modal>
      <Modal
        isOpen={modalCadetesOpen}
        onClose={() => setModalCadeteOpen(false)}


        ariaHideApp={false}
      >
        <div className=" btn-group"> <a style={{ alignSelf: "center" }} ><strong>Consulta Listas de Cadetes Existentes: </strong></a>



        </div>
        <div style={{}}>
          {veoListados ? <>
            <div style={{ display: "flex", width: "500px", justifyContent: "center", maxHeight: "500px", overflow: "auto" }}>

              <CadeteBuscador devuelvo={(value2) => tomoCadete(value2)} /> </div></> : ""}
        </div>
      </Modal>


      <div style={{ display: 'flex', flexWrap: "wrap", textAlign: "center", gridRowEnd: "-moz-initial", width: "100%", padding: "15px", margin: "10px", backgroundColor: "#005588", color: "#ffeeee" }}>

        <h3>Usuario Logueado:{" " + usuario.apellido + ", " + usuario.nombre} </h3>
        <h3 style={{ marginLeft: "20px" }}>{hoy}</h3>
        <h3 style={{ marginLeft: "20px" }}>Division:{devuelveDependenciaConstultada().filter(categoria => categoria.id == usuario.destino)[0].descripcion} </h3>            </div><div>





<form className='form__formulario' onSubmit={handleSubmit(onSubmit)}>

  <section className="datos-personales">

    {/* CABECERA */}


    {/* BLOQUE PRINCIPAL */}
    <div
      className='input-group-text'
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "15px",
        alignItems: "flex-start",
        padding: "20px",
        borderRadius: "10px"
      }}
    >

      {/* CAUSANTE */}
      <div
        className="form-floating"
        style={{ width: "250px" }}
      >
        <input
          type="text"
          className="form-control"
          id="floatingIniciador"
          placeholder="iniciador"
          {...register('iniciador', {
            maxlength: "1024",
            required: true,
            minLength: 3,
          })}
        />

        <label htmlFor="floatingIniciador">
          Causante
        </label>
      </div>

      {/* DIGITAL */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          minHeight: "58px",
          padding: "0 15px",
          border: "1px solid #ced4da",
          borderRadius: "6px",
          backgroundColor: "white"
        }}
      >
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="esDigital"
            {...register("esDigital")}
          />

          <label
            className="form-check-label"
            htmlFor="esDigital"
          >
            ¿Es Digital?
          </label>
        </div>
      </div>

      {/* CADETE */}
      <div
        className="form-floating"
        style={{ width: "250px" }}
      >
        <input
          onClick={devuelveLosCadetes}
          value={esDeCadete}
          type="text"
          className="form-control"
          id="floatingCadete"
          placeholder="Es de Cadete?"
          {...register('esDeCadete')}
        />

        <label htmlFor="floatingCadete">
          Es de Cadete?
        </label>
      </div>

      {/* GRUPO */}
      <div
        className="form-floating"
        style={{ width: "320px" }}
      >
        <select
          className="form-select"
          id="floatingGrupo"
          value={grupoSeleccionado}
          onChange={(e) => setGrupoSeleccionado(e.target.value)}
        >

          <option value="">
            Seleccione un grupo
          </option>

          {grupos.map((grupo) => (
            <option key={grupo} value={grupo}>
              {grupo}
            </option>
          ))}

        </select>

        <label htmlFor="floatingGrupo">
          Grupo de Categoría
        </label>
      </div>

      {/* CATEGORIA */}
      <div
        className="form-floating"
        style={{ width: "320px" }}
      >
        <select
          className="form-select"
          id="floatingidCategoria"
          disabled={!grupoSeleccionado}
          {...register('idCategoria', {
            required: true
          })}
        >

          <option value="">
            Seleccione una categoría
          </option>

          {categoriasFiltradas.map((cate) => (
            <option key={cate.id} value={cate.id}>
              {cate.descripcion}
            </option>
          ))}

        </select>

        <label htmlFor="floatingidCategoria">
          Categoría del Expediente
        </label>
      </div>

      {/* EXP ANTERIOR */}
      <div
        className="form-floating"
        style={{ width: "250px" }}
      >

        <select
          className="form-select"
          id="tieneExptAnterior"
          {...register('tieneExptAnterior', {
            required: true
          })}
        >

          {usuario.nivel < 3 &&
            <option value="Sistema ISeP">
              Sistema ISeP
            </option>
          }

          <option value="Manual">
            Manual
          </option>

          <option value="NO">
            NO
          </option>

        </select>

        <label htmlFor="tieneExptAnterior">
          Tiene Exp ISeP Anterior
        </label>

      </div>

      {/* MANUAL */}
      {habilitaIdExptAnterior === "Manual" && (

        <div
          className="form-floating"
          style={{ width: "300px" }}
        >

          <input
            type="text"
            className="form-control"
            id="idExptAnterior"
            placeholder="idExptAnterior"
            {...register('idExptAnterior')}
          />

          <label htmlFor="idExptAnterior">
            Código Exp / Nota Precedente
          </label>

        </div>

      )}

      {/* SISTEMA ISEP */}
      {habilitaIdExptAnterior === "Sistema ISeP" && (

        <div
          className="form-floating"
          style={{ width: "300px" }}
        >

          <input
            onClick={devuelveTodosExpedientes}
            value={valorExpt}
            type="text"
            className="form-control"
            id="idExptAnteriorSistema"
            placeholder="idExptAnterior"
            {...register('idExptAnterior', {
              required: true
            })}
          />

          <label htmlFor="idExptAnteriorSistema">
            Código Expediente ISeP
          </label>

        </div>

      )}

    </div>

    {/* SEGUNDO BLOQUE */}
    <div
      className='input-group-text mt-3'
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "15px",
        alignItems: "flex-start",
        padding: "20px",
        borderRadius: "10px"
      }}
    >

      {!esDigitalActivo && (
        <div
          className="form-floating"
          style={{ width: "150px" }}
        >

          <input
            type="number"
            className="form-control"
            placeholder="Fojas Iniciales"
            {...register('fojasIniciales', {
              minLength: 1,
              required: !esDigitalActivo
            })}
          />

          <label>
            Fojas Iniciales
          </label>

        </div>
      )}

      <div
        className="form-floating"
        style={{ width: "180px" }}
      >

        <input
          type="date"
          className="form-control"
          {...register('fechaInicial')}
        />

        <label>
          Fecha Anterior
        </label>

      </div>

      <div
        className="form-floating"
        style={{ width: "300px" }}
      >

        <input
          type="text"
          className="form-control"
          placeholder="Exp Ministerio"
          {...register('idExpMinisterio', {
            pattern: /(?:\d{5}|\(\d{3}\))([-\/\.])\d{7}\1\d{1}/
          })}
        />

        <label>
          Código Expediente Ministerio
        </label>

      </div>

      <div
        className="form-floating"
        style={{ width: "240px" }}
      >

        <input
          type="date"
          className="form-control"
          {...register('fechaMinisterio')}
        />

        <label>
          Fecha Exp. Ministerio
        </label>

      </div>

    </div>

    {/* ERROR */}
    {errors.idExpMinisterio?.type === 'pattern' && (
      <span className="aviso_formulario">
        Ojo, el formato debe ser 12345-1234567-1
      </span>
    )}

    {/* CONCEPTO */}
    <div className="form-floating mt-3">

      <textarea
        className="form-control"
        style={{
          height: "120px",
          resize: "none"
        }}
        placeholder="Descripcion de la solicitud"
        id="floatingDescripcion"
        {...register('concepto', {
          required: true,
        })}
      />

      <label htmlFor="floatingDescripcion">
        Concepto
      </label>

    </div>

    {/* BOTONES */}
    <div
      className="contenedor-boton mt-3"
      style={{
        display: "flex",
        gap: "10px"
      }}
    >

      <input
        type="submit"
        disabled={disableBotonFinalizar}
        value="Finalizar"
        className="btn btn-success"
      />

      <input
        type="button"
        value="Cancelar"
        className="btn btn-warning"
        onClick={() => {
          props.myID("dale")
        }}
      />

    </div>

  </section>

</form></div>

    </div>
  );
};
export default FormNuevoExpte;
